import { setting } from "shared/types/Report";
import { SettingCard, SettingTitle, SettingGroupWrap, SettingGroup, SettingLabelWrap, SettingLabel, SettingCheck, SettingSelect } from "../homeworkUi";

interface SentenceSettingProps {
    viewOptions: (name: string, max: number, unit: string) => any[],
    setting: setting
}

const SentenceSettingViewer = ({ viewOptions, setting }: SentenceSettingProps) => {
    return (
        <SettingCard>
            <SettingTitle>문장 학습</SettingTitle>
            <SettingGroupWrap>
                <SettingGroup>
                    <SettingLabelWrap>
                        <SettingCheck type="checkbox" id="listen" name="listening" checked={setting.sentence.listening} disabled />
                        <SettingLabel htmlFor="listen">문장 듣기</SettingLabel>
                    </SettingLabelWrap>
                    <SettingSelect name="sentence_repeat" value={setting.sentence.sentence_repeat} disabled>
                        {viewOptions("", 4, "번")}
                    </SettingSelect>
                </SettingGroup>
            </SettingGroupWrap>
            <SettingGroupWrap>
                <SettingGroup>
                    <SettingLabelWrap>
                        <SettingCheck type="checkbox" id="record" name="record" checked={setting.sentence.record} disabled />
                        <SettingLabel htmlFor="record">문장 녹음</SettingLabel>
                    </SettingLabelWrap>
                </SettingGroup>
            </SettingGroupWrap>
            <SettingGroupWrap>
                <SettingGroup>
                    <SettingLabel>퀴즈 커트라인 (오답)</SettingLabel>
                    <SettingSelect name="cutline" value={setting.sentence.cutline} disabled>
                        {viewOptions("", 4, "개")}
                    </SettingSelect>
                </SettingGroup>
                <SettingGroup>
                    <SettingLabelWrap>
                        <SettingCheck type="checkbox" id="difficulty" name="order" checked={setting.sentence.order} disabled />
                        <SettingLabel htmlFor="difficulty">어순 퀴즈 빈칸(높을수록 어려움)</SettingLabel>
                    </SettingLabelWrap>
                    <SettingSelect name="blank" value={setting.sentence.blank} disabled>
                        {viewOptions("빈칸", 9, "%")}
                    </SettingSelect>
                    <SettingSelect name="pass" value={setting.sentence.pass} disabled>
                        {viewOptions("통과율", 10, "%")}
                    </SettingSelect>
                </SettingGroup>
            </SettingGroupWrap>
        </SettingCard>
    )
}

export default SentenceSettingViewer;
